import React, { useState, useEffect } from 'react';
import '../CSS/Home.css';

import img1 from '../assets/MCMain.png';
import img2 from '../assets/mc-hero2.jpg';
import img3 from '../Images/MC 500.png';
import img4 from '../Images/BlockCrete.png'

const heroImages = [img1, img3, img4, img2];

const Home = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [visibleProducts, setVisibleProducts] = useState(6);

  const featuredProducts = [
    {
      name: 'MUSCLECRETE Tile Adhesive - BASICO',
      category: 'Tile Adhesives',
      description: 'Professional-grade tile adhesive by MUSCLECRETE for superior bonding performance and durability.'
    },
    {
      name: 'MUSCLECRETE MAESTRO Tile Adhesive',
      category: 'Tile Adhesives',
      description: 'Premium tile adhesive solution offering excellent coverage and water resistance for concrete surfaces.'
    },
    {
      name: 'MUSCLECRETE Epoxy Grout MC 500',
      category: 'Grouts',
      description: 'Heavy-duty epoxy grout with exceptional chemical resistance and durability for industrial applications.'
    },
    {
      name: 'MUSCLECRETE AAC Block Adhesive',
      category: 'Block Adhesives',
      description: 'Specialized adhesive for AAC blocks with fast setting time and high bond strength for construction.'
    },
    {
      name: 'MUSCLECRETE Unsanded Cementitious Grout',
      category: 'Grouts',
      description: 'Reliable cementitious grout from PAC Corporation for seamless joint filling and protection.'
    },
    {
      name: 'MUSCLECRETE Installation Tool Kit',
      category: 'Installation Accessories',
      description: 'Complete set of professional tools including spacers, levellers, and mallets for perfect tile installation.'
    }
  ];

  // Set dynamic meta tags for SEO
  useEffect(() => {
    document.title = 'MUSCLECRETE - Premium Tile Adhesive, Grout & Concrete Solutions | PAC Corporation';
    
    const metaTags = {
      description: 'MUSCLECRETE by PAC Corporation offers premium tile adhesives, grouts, and concrete coating solutions. Expert-grade products for professional builders and contractors.',
      keywords: 'MUSCLECRETE, tile adhesive, grout, concrete coating, adhesive cement, PAC Corporation, professional adhesive, construction materials',
    };

    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', metaTags.description);
    }

    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', metaTags.keywords);
    }

    // Update Open Graph tags
    const ogTags = {
      'og:title': 'MUSCLECRETE - Premium Tile Adhesive & Concrete Solutions',
      'og:description': 'Discover MUSCLECRETE by PAC Corporation - premium adhesive and grout solutions for professional construction.',
      'og:url': 'https://www.paccorporation.in/',
    };

    Object.keys(ogTags).forEach(key => {
      let ogTag = document.querySelector(`meta[property="${key}"]`);
      if (ogTag) {
        ogTag.setAttribute('content', ogTags[key]);
      }
    });

    return () => {
      document.title = 'PAC Corporation';
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentImageIndex(prev => (prev + 1) % heroImages.length);
        setFade(true);
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleLoadMore = () => {
    setVisibleProducts(prevCount => prevCount + 3);
  };

  return (
    <div className="home">
      <header className="hero-section">
        <img
          src={heroImages[currentImageIndex]}
          alt="MUSCLECRETE Premium Adhesive & Tile Solutions by PAC Corporation"
          className={`hero ${fade ? 'fade-in' : 'fade-out'}`}
        />
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>MUSCLECRETE by PAC Corporation</h1>
            <p className="hero-subtitle">Professional-Grade Adhesive & Concrete Solutions</p>
            <a href="/products" className="cta-button">Explore Our Products</a>
          </div>
        </div>
      </header>

      <main className="home-main">
        <section className="intro-section" itemScope itemType="https://schema.org/Organization">
          <div className="section-content">
            <h2>About MUSCLECRETE by PAC Corporation</h2>
            <p itemProp="description">
              MUSCLECRETE is the muscle behind your tiles—a premium brand of adhesive and concrete solutions from PAC Corporation, 
              synonymous with Truth, Quality, and Service. We provide the perfect tile adhesive, grout, and construction solutions 
              for a perfect home. Our world-class product portfolio offers a comprehensive range designed to set new benchmarks in 
              the industry. Our adhesive and concrete products are known for impeccable quality and unmatched efficiency, making 
              them the first choice of smart builders, architects, and interior designers.
            </p>
            <div className="intro-features">
              <div className="intro-feature-card">
                <h3>Quality Assurance</h3>
                <p>Industry-leading standards for adhesive and concrete products</p>
              </div>
              <div className="intro-feature-card">
                <h3>Professional Grade</h3>
                <p>Trusted by builders and contractors across the nation</p>
              </div>
              <div className="intro-feature-card">
                <h3>Long-Lasting Results</h3>
                <p>Durable adhesive solutions that stand the test of time</p>
              </div>
            </div>
          </div>
        </section>

        <section className="features-section">
          <div className="section-content">
            <h2>Why Choose MUSCLECRETE?</h2>
            <div className="features-grid">
              <article className="feature-card">
                <h3>Ultra High Strength</h3>
                <p>Ultra-high-strength concrete and adhesive formulations for superior bonding performance.</p>
              </article>
              <article className="feature-card">
                <h3>Rapid Setting Time</h3>
                <p>Fast-setting adhesive for quicker installation and faster construction progress.</p>
              </article>
              <article className="feature-card">
                <h3>Eco-Friendly Solution</h3>
                <p>Environmentally responsible adhesive and concrete coating for sustainable building.</p>
              </article>
              <article className="feature-card">
                <h3>Crack Resistant</h3>
                <p>Advanced adhesive formulation resists cracking and provides long-lasting durability.</p>
              </article>
              <article className="feature-card">
                <h3>Smooth Finish</h3>
                <p>MUSCLECRETE products deliver smooth finishes with high workability for professional results.</p>
              </article>
              <article className="feature-card">
                <h3>Versatile Applications</h3>
                <p>Perfect for driveways, flooring, tiles, industrial sheds, and more concrete applications.</p>
              </article>
            </div>
          </div>
        </section>

        <section className="products-section">
          <div className="section-content">
            <h2>Our World-Class Product Portfolio</h2>
            <div className="product-categories">
              <div className="category-group">
                <h3>Tile Adhesives</h3>
                <ul className="product-list">
                  <li>MC 01 - MUSCLECRETE BASICO Tile Adhesive</li>
                  <li>MC 02 - MUSCLECRETE WOLON Tile Adhesive</li>
                  <li>MC 03 - MUSCLECRETE WOLON PLUS Tile Adhesive</li>
                  <li>MC 04 - MUSCLECRETE MAESTRO Tile Adhesive</li>
                  <li>MC 05 - MUSCLECRETE MAESTRO PLUS Tile Adhesive</li>
                </ul>
              </div>
              <div className="category-group">
                <h3>AAC Block Adhesive</h3>
                <ul className="product-list">
                  <li>MUSCLECRETE Professional AAC Block Adhesive</li>
                </ul>
              </div>
              <div className="category-group">
                <h3>Grouts</h3>
                <ul className="product-list">
                  <li>MC 500 2K Heavy Duty Epoxy Grout</li>
                  <li>MUSCLECRETE Unsanded Cementitious Grout</li>
                </ul>
              </div>
              <div className="category-group">
                <h3>Installation Accessories</h3>
                <ul className="product-list">
                  <li>MUSCLECRETE Tile Spacers</li>
                  <li>MUSCLECRETE Levellers</li>
                  <li>MUSCLECRETE Wedges</li>
                  <li>MUSCLECRETE Rubber Headed Mallet</li>
                  <li>MUSCLECRETE Professional Trowels</li>
                </ul>
              </div>
            </div>

            <h2 className="featured-title">Featured Products</h2>
            <p className="section-intro">Explore MUSCLECRETE's premium adhesive and concrete solutions</p>
            <div className="featured-products-grid">
              {featuredProducts.slice(0, visibleProducts).map((product, index) => (
                <article key={index} className="featured-product-card" itemScope itemType="https://schema.org/Product">
                  <div className="product-header">
                    <h3 itemProp="name">{product.name}</h3>
                    <span className="product-category">{product.category}</span>
                  </div>
                  <p className="product-description" itemProp="description">{product.description}</p>
                  <button className="product-link" aria-label={`View details for ${product.name}`}>Learn More</button>
                </article>
              ))}
            </div>
            {visibleProducts < featuredProducts.length && (
              <div className="load-more-container">
                <button onClick={handleLoadMore} className="load-more-button">
                  Load More Products
                </button>
              </div>
            )}
          </div>
        </section>

        <section className="testimonials-section">
          <div className="section-content">
            <h2>What Our Customers Say</h2>
            <p className="section-subtitle">Trusted by builders, contractors, and homeowners across India</p>
            <div className="testimonials-grid">
              <article className="testimonial-card">
                <div className="testimonial-header">
                  <div className="testimonial-rating">★★★★★</div>
                </div>
                <p className="testimonial-text">"MUSCLECRETE adhesive has transformed our tile installation process. The bond strength is exceptional, and our clients have zero complaints about the finish quality."</p>
                <div className="testimonial-author">
                  <strong>Rajesh Kumar</strong>
                  <span>Professional Contractor, Delhi</span>
                </div>
              </article>

              <article className="testimonial-card">
                <div className="testimonial-header">
                  <div className="testimonial-rating">★★★★★</div>
                </div>
                <p className="testimonial-text">"We switched to MUSCLECRETE for all our projects and haven't looked back. The consistency, setting time, and durability are unmatched. Highly recommended!"</p>
                <div className="testimonial-author">
                  <strong>Priya Deshmukh</strong>
                  <span>Interior Designer, Mumbai</span>
                </div>
              </article>

              <article className="testimonial-card">
                <div className="testimonial-header">
                  <div className="testimonial-rating">★★★★★</div>
                </div>
                <p className="testimonial-text">"After using MUSCLECRETE for over 5 years, I can confidently say it's the best product in the market. Quality is consistent, and their support team is always helpful."</p>
                <div className="testimonial-author">
                  <strong>Vikram Singh</strong>
                  <span>Building Architect, Bangalore</span>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className="cta-section">
          <div className="cta-content">
            <h2>Find Your Perfect Adhesive Solution</h2>
            <p>Discover the MUSCLECRETE difference—professional-grade products trusted by builders nationwide</p>
            <a href="/products" className="primary-cta-button">Browse All Products</a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Home;
